<template>
  <div class="row">
    <card>
      <template>
        <div class="col-lg-12 col-md-6">
          <div class="row">
            <div class="col-lg-4">
              <h3 class="card-title brightness">
                <div class="text-center text-md-left">
                  <base-button
                    type="success"
                    @click.native="modals.addfeeder = true"
                    >Add Feeder Pillar</base-button
                  >
                </div>
                <modal
                  :show.sync="modals.addfeeder"
                  footer-classes="justify-content-center"
                  type="notice"
                >
                  <h3 slot="header" class="modal-title">
                    Add New Feeder Pillar
                  </h3>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-12">
                        <form @submit.prevent>
                          <div>
                            <base-input label="Connection type">
                              <el-select
                                class="select-default"
                                size="large"
                                placeholder="Choose..."
                                v-model="connValue"
                              >
                                <el-option
                                  v-for="a in conntype"
                                  :value="a.value"
                                  :label="a.label"
                                  :key="a.value"
                                ></el-option>
                              </el-select>
                            </base-input>
                            <div v-if="connValue === 'nbiot'">
                              <base-input
                                v-model="fpinfo.devicetoken"
                                label="Device Token"
                                placeholder="Name"
                              ></base-input>
                            </div>
                            <div v-if="connValue === 'lora'">
                              <base-input
                                v-model="fpinfo.devicetoken"
                                label="Device Token"
                                placeholder="Name"
                              ></base-input>
                              <base-input
                                v-model="fpinfo.appkey"
                                label="Application key"
                                placeholder="Name"
                              ></base-input>
                            </div>

                            <base-input
                              v-model="fpinfo.name"
                              label="Feeder pillar name"
                              placeholder="Name"
                            ></base-input>
                            <base-input
                              v-model="fpinfo.desc"
                              label="Description"
                              placeholder="Description"
                            ></base-input>
                            <base-input
                              v-model="fpinfo.code"
                              label="Feeder pillar code"
                              placeholder="Code"
                            ></base-input>
                            <base-input
                              v-model="fpinfo.latitude"
                              label="Latitude"
                              placeholder="Latitude"
                            ></base-input>
                            <base-input
                              v-model="fpinfo.longitude"
                              label="Longitude"
                              placeholder="Longitude"
                            ></base-input>
                            <base-input
                              v-model="fpinfo.tariff"
                              label="Electricity Tariff"
                              placeholder="Tariff"
                            ></base-input>

                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click.native="addFeederPillar()"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.addfeeder = false"
                              >Cancel</base-button
                            >
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </modal>
                <modal
                  :show.sync="modals.editfeeder"
                  footer-classes="justify-content-center"
                  type="notice"
                >
                  <h3 slot="header" class="modal-title">
                    Edit Feeder Pillar Form
                  </h3>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-12">
                        <form @submit.prevent>
                          <div>
                            <base-input
                              v-model="fpinfo.name"
                              label="Device Brand / Manufacturer"
                              placeholder="Device Brand / Manufacturer"
                            ></base-input>
                            <base-input
                              v-model="fpinfo.code"
                              label="Model Number"
                              placeholder="Model Number"
                              disabled
                            ></base-input>
                            <base-input
                              v-model="fpinfo.latitude"
                              label="Latitude"
                              placeholder="Latitude"
                            ></base-input>
                            <base-input
                              v-model="fpinfo.longitude"
                              label="Longitude"
                              placeholder="Longitude"
                            ></base-input>
                            <base-input
                              id="deviceassoc"
                              label="Device Associate"
                              placeholder="Device associate to the cluster"
                              name="required"
                              type="text"
                              required
                            >
                              <el-select
                                multiple
                                class="select-default"
                                size="large"
                                placeholder="Choose..."
                                v-model="deviceid"
                              >
                                <el-option
                                  v-for="device in available_dev"
                                  :value="device.value"
                                  :label="device.label"
                                  :key="device.available"
                                ></el-option>
                              </el-select>
                            </base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click.native="editFeederPillar()"
                              >Edit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.editfeeder = false"
                              >Cancel</base-button
                            >
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </modal>
                <div slot="footer"></div>
              </h3>
            </div>
          </div>
        </div>

        <div class="col-lg-12 col-md">
          <div>
            <div
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <el-select
                class="select-primary mb-3 pagination-select d-none d-sm-block"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>

              <base-input type="success">
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input>
            </div>
            <!-- table data -->
            <el-table
              :data="tableData"
              :header-cell-style="{
                background: 'transparent',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
            >
              <el-table-column
                min-width="150"
                sortable
                label="Name"
                property="name"
              ></el-table-column>
              <!-- <el-table-column
                min-width="150"
                sortable
                label="Description"
                property="desc"
              ></el-table-column> -->
              <el-table-column
                min-width="150"
                sortable
                label="Code"
                property="code"
              ></el-table-column>
              <el-table-column
                min-width="190"
                sortable
                label="Latitude"
                property="latitude"
              ></el-table-column>
              <el-table-column
                min-width="150"
                sortable
                align="right"
                header-align="right"
                label="Longitude"
                property="longitude"
              ></el-table-column>
              <el-table-column :min-width="100" align="right" label="Actions">
                <div slot-scope="props">
                  <el-tooltip
                    content="Device Associated"
                    placement="bottom"
                    effect="light"
                  >
                    <base-button
                      @click.native="modals.deviceassociated = true"
                      @click="getDeviceAssociated(props.row)"
                      class="edit btn-link"
                      type="success"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-notes"></i>
                    </base-button>
                  </el-tooltip>
                  <el-tooltip content="Edit" placement="bottom" effect="light">
                    <base-button
                      @click.native="modals.edit = true"
                      @click="getRow(props.row)"
                      class="edit btn-link"
                      type="success"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>
                  <el-tooltip
                    content="Delete"
                    placement="bottom"
                    effect="light"
                  >
                    <base-button
                      @click.native="handleDelete(props.$index, props.row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>

          <!-- modal to dispkay device details -->
          <modal
            :show.sync="modals.deviceassociated"
            footer-classes="justify-content-center"
            type="large"
          >
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent>
                    <div class="row justify-content-center mt-12">
                      <div class="col-sm-12">
                        <div>
                          <h3 style="color: #344675">
                            Feeder Pillar Information
                          </h3>
                          <el-table
                            :data="lightsTable"
                            style="background-color: #1d253b"
                            :header-cell-style="{
                              background: 'transparent',
                              border: 'transparent',
                              'padding-bottom': '0%',
                              'padding-center': '10px',
                              color: 'white',
                            }"
                            :cell-style="{
                              border: 'transparent',
                              'padding-center': '20px',
                            }"
                          >
                            <!-- <el-table-column
                              min-width="190"
                              sortable
                              label="Device ID"
                              property="deviceid"
                            ></el-table-column> -->
                            <el-table-column
                              min-width="150"
                              sortable
                              align="left"
                              header-align="left"
                              label="Device Name"
                              property="devicename"
                            ></el-table-column>
                            <el-table-column
                              min-width="150"
                              sortable
                              align="left"
                              header-align="left"
                              label="Device Latitude"
                              property="devicelat"
                            ></el-table-column>
                            <el-table-column
                              min-width="150"
                              sortable
                              align="left"
                              header-align="left"
                              label="Device Longitude"
                              property="devicelong"
                            ></el-table-column>
                            <el-table-column
                              :min-width="100"
                              align="right"
                              label="Actions"
                            >
                              <div slot-scope="props">
                                <el-tooltip
                                  content="Unpair device"
                                  placement="bottom"
                                  effect="light"
                                >
                                  <base-button
                                    @click="unpairDevices(props.row)"
                                    class="edit btn-link"
                                    type="danger"
                                    size="sm"
                                    icon
                                  >
                                    <i class="tim-icons icon-simple-remove"></i>
                                  </base-button>
                                </el-tooltip>
                              </div>
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                      <div>
                        <base-button
                          class="mt-3"
                          type="danger"
                          @click.native="modals.deviceassociated = false"
                          >Cancel</base-button
                        >
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </modal>

          <div
            slot="footer"
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          >
            <div class>
              <p class="card-category">
                Showing {{ pagination.from + 1 }} to {{ pagination.to }} of
                {{ pagination.total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></base-pagination>
          </div>
          <!-- </h3>-->
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Modal, BasePagination } from "src/components";
import { Slider, BaseSwitch } from "src/components/index";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import users from "./users"; //read users from this file
import Fuse from "fuse.js";

var moment = require("moment"); // Change date format

export default {
  components: {
    [DatePicker.name]: DatePicker,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
  },
  data() {
    return {
      //feeder pillar details

      deviceid: "",
      connValue: "none",
      lightsTable: [],
      conntype: [
        {
          label: "NB-IoT",
          value: "nbiot",
        },
        {
          label: "LoraWAN",
          value: "lora",
        },
        {
          label: "No Connectivity",
          value: "none",
        },
      ],
      fpinfo: {
        name: "",
        desc: "",
        code: "",
        latitude: "",
        longitude: "",
        appkey: "",
        devicetoken: "",
        tariff: "",
      },
      modals: {
        addfeeder: false,
        editfeeder: false,
        deviceassociated: false,
      },
      available_dev: [],
      tableData: [],
      searchQuery: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      companyID: "",
    };
  },
  methods: {
    unpairDevices(row) {
      swal({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, unpair it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.unpair(row);
          swal({
            title: "Unpaired!",
            text: `You unpair ${row.devicename}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    unpair(row) {},
    getFpList() {
      this.tableData = [];
      this.$http
        .get(":8002/api/v1/manage/feeder")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              let obj = {
                name: response[i].fp_name,
                id: response[i].fp_id,
                code: response[i].fp_code,
                latitude: response[i].lat,
                longitude: response[i].lon,
              };
              this.tableData.push(obj);
            }
          } else {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRow(row) {
      console.log(row);
      this.modals.editfeeder = true;
      this.fpinfo.name = row.name;
      this.fpinfo.code = row.code;
      this.fpinfo.latitude = row.latitude;
      this.fpinfo.longitude = row.longitude;
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteFeederPillar(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    deleteFeederPillar(row) {
      console.log(row, row.code);
      this.$http.delete(":8002/api/v1/manage/feeder/" + row.id).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          swal({
            type: "success",
            text: res.message,
          });
          this.modals.addfeeder = false;
          this.fpinfo.name = "";
          this.fpinfo.desc = "";
          this.fpinfo.code = "";
          this.fpinfo.latitude = "";
          this.fpinfo.longitude = "";
          this.getFpList();
        } else {
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: res.message,
          });
        }
      });
      console.log(row);
    },
    addFeederPillar() {
      console.log(
        this.fpinfo.name,
        this.fpinfo.code,
        this.fpinfo.latitude,
        this.fpinfo.longitude
      );
      if (
        this.fpinfo.name == "" ||
        this.fpinfo.desc == "" ||
        this.fpinfo.code == "" ||
        this.fpinfo.latitude == "" ||
        this.fpinfo.longitude == "" ||
        this.fpinfo.tariff == ""
      ) {
        swal({
          type: "error",
          title: "Oops...  All details are required!",
        });
      } else {
        let payload = {
          fpname: this.fpinfo.name,
          fpdesc: this.fpinfo.desc,
          fpcode: this.fpinfo.code,
          connection_type: this.connValue,
          token: this.fpinfo.devicetoken,
          appkey: this.fpinfo.appkey,
          tariff: parseFloat(this.fpinfo.tariff),
          lat: parseFloat(this.fpinfo.latitude),
          lon: parseFloat(this.fpinfo.longitude),
        };

        console.log(payload);

        // send
        this.$http.post(":8002/api/v1/manage/feeder", payload).then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              type: "success",
              text: res.message,
            });
            this.modals.addfeeder = false;
            // this.fpinfo.name = ""
            this.getFpList();
          } else {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          }
        });
      }
    },
    getDeviceAssociated(row) {
      this.lightsTable = [];
      console.log(row);
      let payload = {
        deviceid: row.id,
        devicename: row.name,
        fpid: row.code,
      };
      this.$http
        .get(":8002/api/v1/manage/feeder/assoclights/" + row.id)
        .then((res) => {
          if (!res.error) {
            console.log(res.message);
            let response = res.message;
            for (var i = 0; i < response.length; i++) {
              let obj = {
                deviceid: response[i].DeviceID,
                devicename: response[i].DeviceName,
                devicelat: response[i].Latitude,
                devicelong: response[i].Longitude,
              };
              this.lightsTable.push(obj);
            }
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editFeederPillar() {
      //update info
      console.log(
        this.fpinfo.name,
        this.fpinfo.code,
        this.fpinfo.latitude,
        this.fpinfo.longitude
      );

      let feederpillarinfo = {
        fpname: this.fpinfo.name,
        fpcode: this.fpinfo.code,
        lat: parseFloat(this.fpinfo.latitude),
        lon: parseFloat(this.fpinfo.longitude),
      };
      //   send
      this.$http
        .put(":8002/api/v1/manage/feeder/" + this.fpinfo.code, feederpillarinfo)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              type: "success",
              text: res.message,
            });
            this.modals.editfeeder = false;
            this.fpinfo.name = "";
            this.desc = "";
            this.fpinfo.code = "";
            this.fpinfo.latitude = "";
            this.fpinfo.longitude = "";
            // this.getFpList()
          } else {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          }
        });

      if (this.deviceid.length !== 0) {
        //attach light to feeder pillar
        console.log("masuk");
        for (var i = 0; i < this.deviceid.length; i++) {
          console.log(this.deviceid[i]);
        }

        let payload = {
          fpcode: this.fpinfo.code,
          lightid: this.deviceid,
        };
        console.log(payload);
        // send
        this.$http
          .post(":8002/api/v1/manage/feeder/attach", payload)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              swal({
                type: "success",
                text: res.message,
              });
              this.modals.editfeeder = false;
              this.fpinfo.name = "";
              this.desc = "";
              this.fpinfo.code = "";
              this.fpinfo.latitude = "";
              this.fpinfo.longitude = "";
              this.getFpList();
            } else {
              swal({
                type: "error",
                title: "Oops... Something went wrong!",
                text: res.message,
              });
            }
          });
      }

      this.getFpList();
    },
    handleEdit(index, row) {
      swal({
        title: "Are you sure?",
        text: `You want to edit ${this.getRowData.devicename}`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, edit it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.editDevice();
          swal({
            title: "Edited!",
            text: `You edited ${this.getRowData.devicename}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    getAssocDevice() {
      console.log(this.companyID);
      this.$http
        .get(":8002/api/v1/manage/feeder/lights/" + this.companyID)
        .then((res) => {
          if (!res.error) {
            console.log(res);
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let obj = {
                value: response[i].DeviceID,
                label: response[i].DeviceName,
              };
              this.available_dev.push(obj);
            }
          } else {
            console.log(res.message);
          }
        });
    },
  },

  created() {
    this.getFpList();

    let jwt_token = this.$cookie.get("token").split(".")[1];
    jwt_token = JSON.parse(atob(jwt_token));
    console.log("Company id:", jwt_token.Companyid);
    this.companyID = jwt_token.Companyid;
    console.log(this.companyID);

    this.getAssocDevice();
  },
  mounted() {},
  watch: {},
};
</script>
<style>
.head h3 {
  display: inline;
  padding-bottom: 10px;
}
.brightness p {
  display: inline;
}
.bright slider {
  display: inline;
}
.chartButton {
  text-align: right;
}
#fileName {
  margin: 3%;
  color: black;
  font-weight: bold;
}
</style>
